import { useCallback } from 'react';

interface UseVideoPlaybackProps {
  videoRef: React.RefObject<HTMLVideoElement>;
  isAnnotating: boolean;
}

export function useVideoPlayback({ videoRef, isAnnotating }: UseVideoPlaybackProps) {
  const play = useCallback(async () => {
    if (isAnnotating) {
      return; // Prevent playback while annotating
    }
    
    if (videoRef.current) {
      try {
        await videoRef.current.play();
      } catch (error) {
        console.error('Error playing video:', error);
      }
    }
  }, [videoRef, isAnnotating]);

  const pause = useCallback(() => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
  }, [videoRef]);

  return { play, pause };
}